import { render } from "./PaymentTextInput.vue?vue&type=template&id=b0bdc116"
import script from "./PaymentTextInput.vue?vue&type=script&lang=js"
export * from "./PaymentTextInput.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__